<script>
import AuthLayout from "../templates/AuthLayout.vue";
import BasicInput from "../../../theme/atoms/BasicInput.vue";
import BasicButton from "../../../theme/atoms/BasicButton.vue";
import ForgotPasswordCard from "../organisms/Forgot/ForgotPasswordCard.vue";
import ForgotPasswordModal from "../organisms/Forgot/ForgotPasswordModal.vue";
export default {
    name: "ForgotPasswordPage",
    components: {
        ForgotPasswordModal,
        ForgotPasswordCard,
        AuthLayout,
        BasicInput,
        BasicButton
    },
    props: {
        candidates: {
            type: Array,
            required: false,
        },
        successMessage: {
            type: String,
            required: false
        },
        errors: {
            type: Array,
            required: false
        }
    },
    data() {
        return {
            recentLogins: []
        }
    },
    methods: {
        handleClick(candidate) {
            this.$refs.forgotPasswordModal.open(candidate);
        },

        handleForgotPassword(message) {
            this.$refs.forgotPasswordModal.close();
            this.$notify({
                type: 'success',
                text: message
            });
            setTimeout(() => {
                location.href = '/auth';
            }, 3000);
        }
    },
}
</script>

<template>
    <auth-layout>
        <forgot-password-card  @click="handleClick" :success-message="successMessage" :candidates="candidates" :errors="errors"/>
        <forgot-password-modal v-on:forgot-password-success="handleForgotPassword" ref="forgotPasswordModal"/>
    </auth-layout>
</template>
